/**
 * OVERRIDE querystring.js
 * REASON: Add option to fetch querystring info contextually.
 * FILE: https://github.com/plone/volto/blob/15.11.1/src/actions/querystring/querystring.js
 * FILE VERSION: Volto 15.11.1
 * DATE: 2025-01-29
 * DEVELOPER: @davisagli
 */

/**
 * Querystring actions.
 * @module actions/querystring/querystring
 */

import { GET_QUERYSTRING } from '@plone/volto/constants/ActionTypes';
import { flattenToAppURL } from '@plone/volto/helpers';

/**
 * Get querystring.
 * @function getQuerystring
 * @returns {Object} Get querystring action.
 */
export function getQuerystring() {
  return (dispatch, getState) => {
    const state = getState();
    const url = flattenToAppURL(state.content.data?.['@id']);
    if (url && url !== state.querystring.context) {
      dispatch({
        type: GET_QUERYSTRING,
        context: url,
        request: {
          op: 'get',
          path: `${url}/@querystring`,
        },
      });
    }
  };
}
